import { useRobotCleaningProgressEntry } from './useRobotCleaningProgressEntry';
import { RobotUtils } from 'app/utils/robot/RobotUtils';
import { Machine } from 'app/modules/machine-inventory/interfaces/Machine.types';

/** CV50: live task progress while cleaning. Other models return `fallbackPercent`. */
export const useCv50CleaningProgressPercent = (
  robot: Machine,
  isRobotCleaning: boolean,
  fallbackPercent: number
): number => {
  const isCV50 = RobotUtils.getRobotType(robot?.type?.name) === 'CV50';

  const entry = useRobotCleaningProgressEntry(robot, isCV50 && isRobotCleaning);

  if (!isCV50) {
    return fallbackPercent;
  }

  return entry?.progress ?? 0;
};
